import React, {useEffect} from "react";
import {Chart} from "chart.js";
import toPersianNumber from "../../../helpers/actions/toPersianNumber"
import numberWithCommas from "../../../helpers/actions/numberWithCommas"

let myLineChart;
Chart.defaults.global.defaultFontFamily = "IRANSans";
const BarChart = (props) => {
    // console.log(props.data);
    useEffect(() => {
        let array1 = []
        let array2 = []
        // console.log(props.data);
        Object.keys(props.data).forEach(item => {
            if (item == "active" || item == "deactivate") {
                // console.log(item,props.data[item].available);
                array1.push(props.data[item].available)
                array2.push(props.data[item].unavailable)
            } else {
                array1.push(props.data[item])
            }
        })
        array1 = array1.reverse()
        array2 = array2.reverse()
        // console.log(array1,array2);
        const myChartRef = props.refrence.current.getContext("2d");
        window[myLineChart + props.tag] = new Chart(myChartRef, {
            type: "bar",
            data: {
                //Bring in data
                labels: props.labels,
                datasets: [
                    {
                        label: "تنوع‌های دارای موجودی ",
                        data: array1,
                        fill: false,
                        borderColor: "#192a56",
                        backgroundColor: "#192a56",
                    },
                    {
                        label: "تنوع‌های بدون موجودی ",
                        data: array2,
                        fill: false,
                        borderColor: "#e3d185",
                        backgroundColor: "#e3d185",
                    }
                ]
            },
            gridLines: {
                display: false
            },
            options: {
                // responsive: true,
                tooltips: {
                    // Disable the on-canvas tooltip
                    enabled: false,
                    callbacks: {
                        title: function () {
                        }
                    },

                    custom: function (tooltipModel) {
                        // Tooltip Element
                        let tooltipEl = document.getElementById('chartjs-tooltip');

                        // Create element on first render
                        if (!tooltipEl) {
                            tooltipEl = document.createElement('div');
                            tooltipEl.id = 'chartjs-tooltip';
                            tooltipEl.innerHTML = '<table></table>';
                            document.body.appendChild(tooltipEl);
                        }

                        // Hide if no tooltip
                        if (tooltipModel.opacity === 0) {
                            tooltipEl.style.opacity = 0;
                            return;
                        }

                        // Set caret Position
                        tooltipEl.classList.remove('above', 'below', 'no-transform');
                        if (tooltipModel.yAlign) {
                            tooltipEl.classList.add(tooltipModel.yAlign);
                        } else {
                            tooltipEl.classList.add('no-transform');
                        }

                        function getBody(bodyItem) {
                            return bodyItem.lines;
                        }

                        // Set Text
                        if (tooltipModel.body) {
                            let titleLines = tooltipModel.title || [];
                            let bodyLines = tooltipModel.body.map(getBody);

                            let innerHtml = '<thead>';

                            titleLines.forEach(function (title) {
                                innerHtml += '<tr><th>' + title + '</th></tr>';
                            });
                            innerHtml += '</thead><tbody>';

                            bodyLines.forEach(function (body, i) {
                                let colors = tooltipModel.labelColors[i];
                                let style = 'background:' + colors.backgroundColor;
                                style += '; border-color:' + colors.borderColor;
                                style += '; border-width: 2px';
                                style += '; color: #ffffff';
                                style += '; padding: 5px 5px';
                                style += '; border-radius: 4px';
                                let span = '<span style="' + style + '">' + toPersianNumber(numberWithCommas(body)) + '</span>';
                                innerHtml += '<tr><td>' + span + '</td></tr>';
                            });
                            innerHtml += '</tbody>';

                            let tableRoot = tooltipEl.querySelector('table');
                            tableRoot.innerHTML = innerHtml;
                            console.log(tableRoot);
                        }

                        // `this` will be the overall tooltip
                        let position = this._chart.canvas.getBoundingClientRect();

                        // Display, position, and set styles for font
                        tooltipEl.style.opacity = 1;
                        tooltipEl.style.position = 'absolute';
                        tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
                        tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
                        tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                        tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
                        tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                        tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
                        tooltipEl.style.pointerEvents = 'none';
                        // tooltipEl.style.background = 

                    }
                },
                legend: {
                    display: false,

                },
                scales: {
                    xAxes: [{
                        stacked: true,
                        barThickness: 36,
                        gridLines: {
                            display: false

                        }
                    }],
                    yAxes: [{
                        // suggestedMax: 5000,

                        stacked: true,
                        gridLines: {
                            display: false
                        },
                        ticks: {
                            display: false,

                        }

                    }]
                },

            },
        });
    }, [props]);
    return <canvas ref={props.refrence} id={props.tag} style={{boxSizing: "border-box", width: "90%"}}
                   height="297"></canvas>
}
export default BarChart